import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from 'bna-angular-auth-client';
import { ClientSettingsService } from 'src/app/core/services/auth/client-settings.service';
import { AppSettings } from 'src/app/shared/constants/app-settings.constants';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit {
  constructor(
    private router: Router,
    private userSessionService: UserSessionService,
    private clientSettingService: ClientSettingsService
  ) { }

  ngOnInit() {
    this.userSessionService.signOut(true);
    this.clientSettingService.remove(AppSettings.AgencySelectionPopedUp, false);
    this.router.navigate(['sign-in']);
  }
}
